import "./style.css";
import layout from "./layout.html";
import { getInstance } from "@app";
import chapters from "@data/chapters.json";
import Carousel from "@components/Carousel";

export default class Nav {
  static selector = ".nav";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
    this.animatedTexts = block.querySelectorAll(".animated-text");
    this.menuItemTemplate = block.querySelector("#menu-item-template");
    this.menuItemsNode = block.querySelector(".nav__menu__items");
    this.menuNode = block.querySelector(".nav__menu");

    this.animatedTextsInstances = [];
    this.opened = false;
    this.duration = 600;

    this.index = 0;
  }

  updateActiveNavLink = () => {
    /*const route = window.location.pathname.replace(/\/$/, "");
    this.navItemNodes &&
      this.navItemNodes.forEach((node) => {
        node.classList.toggle(
          "underlineable--active",
          node.pathname.replace(/\/$/, "") === route.replace(/\/$/, "")
        );
      });*/
  };

  hide = () => {
    if (this.socials) {
      this.socials.style.opacity = null;
    }
    this.animatedTextsInstances.forEach((instance) => {
      if (instance.hide) {
        instance.hide();
      }
    });

    this.block.style.pointerEvents = null;

    setTimeout(() => {
      document.body.classList.remove("nav-visible");
    }, this.duration / 4);
  };

  show = () => {
    document.body.classList.add("nav-visible");

    setTimeout(() => {
      this.animatedTextsInstances.forEach((instance) => {
        if (instance.show) {
          instance.show();
        }
      });
    }, this.duration / 2);
  };

  changeState = () => {
    if (!this.opened) {
      this.carousel.setIndex(-this.index);
      this.show();
    } else {
      this.hide();
    }

    this.opened = !this.opened;
  };

  setupMenuItem = (chapter) => {
    return new Promise(async (resolve, reject) => {
      const menuItemNode =
        this.menuItemTemplate.content.firstElementChild.cloneNode(true);
      menuItemNode.dataset.navChapterId = `chapter-${chapter.cover.title.number}`;
      menuItemNode.href = `#chapter-${chapter.cover.title.number}`;
      menuItemNode.addEventListener("click", () => {
        this.onNavItemClicked(chapter.cover.title.number);
      });

      const contentBackgroundNode = menuItemNode.querySelector(
        ".nav__menu__items__item__content__background__image"
      );
      contentBackgroundNode.style.background = `linear-gradient(0deg, #D3DCDE, #D3DCDE), linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${chapter.cover.image.src}) no-repeat center`;
      contentBackgroundNode.style.backgroundSize = "cover, cover, cover";

      const contentTitleNode = menuItemNode.querySelector(
        ".nav__menu__items__item__content__title"
      );
      contentTitleNode.textContent = `${chapter.cover.title.text}`;

      const numberNode = menuItemNode.querySelector(
        ".nav__menu__items__item__number"
      );
      numberNode.textContent =
        `capitolo ` + `${chapter.cover.title.number}`.padStart(2, "0");

      resolve(menuItemNode);
    });
  };

  setup = async () => {
    return new Promise(async (resolve, reject) => {
      await Promise.all(
        Object.values(chapters).map(async (chapter) => {
          const node = await this.setupMenuItem(chapter);
          if (node) {
            this.menuItemsNode.appendChild(node);
          }
        })
      );

      this.carousel = new Carousel(this.menuNode);

      resolve();
    });
  };

  chapterChanged = (params) => {
    const { chapterNumber } = params;
    this.updateIndex(chapterNumber);
  };

  updateIndex = (chapterNumber) => {
    chapterNumber = parseInt(chapterNumber, 10) - 1;
    this.index = chapterNumber;
    this.carousel.setIndex(-this.index);
    this.navItemNodes.forEach((node, index) => {
      node.classList.toggle(
        "nav__menu__items__item--current",
        index === Math.abs(this.index)
      );
    });
  };

  onNavItemClicked = (chapterNumber) => {
    this.updateIndex(chapterNumber);
  };

  onToggleNavClicked = () => {
    this.changeState();
  };

  onReady = () => {
    return new Promise(async (resolve, reject) => {
      this.mounted = true;

      await this.setup();
      this.navItemNodes = this.block.querySelectorAll(
        ".nav__menu__items__item"
      );

      resolve();
    });
  };

  onComplete = () => {
    return new Promise(async (resolve, reject) => {
      this.completed = true;

      this.updateActiveNavLink();

      this.toggleButtons = document.querySelectorAll(".toggle-nav");

      this.toggleButtons.forEach((button) => {
        button.addEventListener("click", this.onToggleNavClicked);
      });

      if (this.animatedTexts) {
        this.animatedTexts.forEach((node) => {
          const instance = getInstance(node);

          if (instance) {
            this.animatedTextsInstances.push(instance);
          }
        });
      }

      resolve();
    });
  };

  onPageChangeComplete = () => {
    return new Promise(async (resolve, reject) => {
      this.updateActiveNavLink();
      resolve();
    });
  };
}
